<lib-gung-text-input [gungTranslate]="'OUTPUT_FILE_NAME'" [(ngModel)]="fileName"></lib-gung-text-input>
<lib-gung-text-input [gungTranslate]="'ASSORTMENT'" [(ngModel)]="assortment"></lib-gung-text-input>
<button type="button" class="mt-2 btn btn-sm btn-primary" translate (click)="exportFile()">EXPORT</button>
